import * as React from 'react';
import * as cx from 'classnames';
import './Section.css';

interface Props {
    title?: string;
    className?: string;
}

class Section extends React.Component<Props> {
    render() {
        const {
            title = '',
            children,
            className
        } = this.props;
        const classes = cx('section-wrapper', className);

        return (
            <section className={classes}>
                { title &&
                    <h1>{title}</h1>
                }
                {children}
            </section>
        );
    }
}

export default Section;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/Section.tsx